import React from "react";
import "../../style/ListFeaturedSeeAll.css";
import { BiHeart } from "react-icons/bi";

function ListFeaturedSeeAll({ datas }) {
  return (
    <div>
      <section>
        <div className="listConatiner">
          {/* <div className="featuredList">
            <div className="d-flex align-items-center firstSectionList">
              <div className="showCaseList">
                <div className="heart_onimg">
                  <BiHeart /> <span className="ms-1">5</span>
                </div>
                <img
                  src="image 32 (6).png"
                  alt="showcase"
                  className="mainImg"
                />
              </div>
              <div className="nameSection">
                <div className="d-flex align-items-center">
                  <p className="realName">DeGods</p>
                  <img src="signed 1.png" alt="tick" className="tick ms-2" />
                </div>
                <p className="petName">Azuki</p>
              </div>
            </div>
            <div className="secondSection">
              <div className="priceSection">
                <span>Price</span>
                <p>16.5 ETH</p>
              </div>
              <div className="priceSection">
                <span>Highest bid</span>
                <p>10.5 ETH</p>
              </div>
              <div className="buyNowList">
                <button>Buy Now</button>
              </div>
            </div>
          </div> */}
          {datas.map((e, index) => {
            return (
              <div className="featuredList" key={index}>
                <div className="d-flex align-items-center firstSectionList">
                  <div className="showCaseList">
                    <div className="heart_onimg">
                      <BiHeart /> <span className="ms-1">5</span>
                    </div>
                    <img src={e.mainImg} alt="showcase" className="mainImg" />
                  </div>
                  <div className="nameSection">
                    <div className="d-flex align-items-center">
                      <p className="realName"> {e.profileName}</p>
                      <img
                        src="signed 1.png"
                        alt="tick"
                        className="tick ms-2"
                      />
                    </div>
                    <p className="petName">Azuki</p>
                  </div>
                </div>
                <div className="secondSection">
                  <div className="priceSection">
                    <span>Price</span>
                    <p>16.5 ETH</p>
                  </div>
                  <div className="priceSection">
                    <span>Highest bid</span>
                    <p>10.5 ETH</p>
                  </div>
                  <div className="buyNowList">
                    <button>Buy Now</button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}

export default ListFeaturedSeeAll;
